/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rate: NonNullable<unknown> }} Onboarding_V1_Projection_Average_ReturnInputs */

const en_onboarding_v1_projection_average_return = /** @type {(inputs: Onboarding_V1_Projection_Average_ReturnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} avg. return`)
};

const de_onboarding_v1_projection_average_return = /** @type {(inputs: Onboarding_V1_Projection_Average_ReturnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} durchschnittliche Rendite`)
};

const pt_br2_onboarding_v1_projection_average_return = /** @type {(inputs: Onboarding_V1_Projection_Average_ReturnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} de retorno médio`)
};

const tr_onboarding_v1_projection_average_return = /** @type {(inputs: Onboarding_V1_Projection_Average_ReturnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ort. getiri: ${i?.rate}`)
};

const zh_cn2_onboarding_v1_projection_average_return = /** @type {(inputs: Onboarding_V1_Projection_Average_ReturnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} 平均回报率`)
};

const zh_hk2_onboarding_v1_projection_average_return = /** @type {(inputs: Onboarding_V1_Projection_Average_ReturnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} 平均回報率`)
};

const ko_kr2_onboarding_v1_projection_average_return = /** @type {(inputs: Onboarding_V1_Projection_Average_ReturnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} 평균 수익률`)
};

const ru_ru2_onboarding_v1_projection_average_return = /** @type {(inputs: Onboarding_V1_Projection_Average_ReturnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} средняя доходность`)
};

const es_419_onboarding_v1_projection_average_return = /** @type {(inputs: Onboarding_V1_Projection_Average_ReturnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} de rendimiento promedio`)
};

/**
* | output |
* | --- |
* | "{rate} avg. return" |
*
* @param {Onboarding_V1_Projection_Average_ReturnInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_projection_average_return = /** @type {((inputs: Onboarding_V1_Projection_Average_ReturnInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Projection_Average_ReturnInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_projection_average_return(inputs)
	if (locale === "de") return de_onboarding_v1_projection_average_return(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_projection_average_return(inputs)
	if (locale === "tr") return tr_onboarding_v1_projection_average_return(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_projection_average_return(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_projection_average_return(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_projection_average_return(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_projection_average_return(inputs)
	return es_419_onboarding_v1_projection_average_return(inputs)
});